import { Props } from '~/containers/QuoteEstimates';
import { isAutoOnlyMediaAlphaActivated } from '~/util/optimizelyHelpers';

const step = {
  route: '/homeowners-insurance/quotes/offers',
  isAccessible: ({ application }: Props) =>
    application.isAutoOnly && isAutoOnlyMediaAlphaActivated(),
};

export default step;
